// extracted by mini-css-extract-plugin
module.exports = {"container":"Rfpq_container__FCGn6","form-container":"Rfpq_form-container__1HJ7l"};